import React from "react";
import { Tag } from "antd";
import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";

// Centralized status metadata
const STATUS_META = {
  pending: {
    label: "Under Review",
    color: "#FFECB3",
    textColor: "#000",
    icon: <ClockCircleOutlined />,
  },
  qualified: {
    label: "Qualified",
    color: "#81C784",
    textColor: "#000",
    icon: <CheckCircleOutlined />,
  },
  disqualified: {
    label: "Disqualified",
    color: "#E57373",
    textColor: "#000",
    icon: <CloseCircleOutlined />,
  },
  awaiting_submission: {
    label: "Awaiting Submission",
    color: "#64B5F6",
    textColor: "#000",
    icon: <ClockCircleOutlined />,
  },
};

/**
 * Read-only StatusTag component
 * Props:
 *  - status: any value (will be stringified)
 *  - style: custom style overrides
 *  - className: optional className
 */
export function StatusTag({ status, style = {}, className = "" }) {
  // Ensure we have a string key
  const key = String(status);
  const meta = STATUS_META[key] || {
    label: key.replace(/_/g, " "),
    color: "#DDD",
    textColor: "#000",
    icon: null,
  };

  return (
    <Tag
      icon={meta.icon}
      className={className}
      style={{
        backgroundColor: meta.color,
        color: meta.textColor,
        borderRadius: 4,
        padding: "0 8px",
        fontWeight: 500,
        display: "inline-flex",
        alignItems: "center",
        ...style,
      }}
    >
      {meta.label}
    </Tag>
  );
}
